import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import MobileSubNavigator from '../../../components/MobileSubNavigator';
import { getHomeLinks } from '../../../utils/homeLinks';

const Container = styled.div`
  width: 100%;
  padding: 1rem;
  background: #f8f9fa;
  min-height: 100vh;
  box-sizing: border-box;
`;

const Header = styled.div`
  background: white;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  font-size: 1.25rem;
  color: #212529;
  margin: 0 0 1rem 0;
  font-weight: 600;
`;

const SearchBox = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 0.875rem;
`;

const Button = styled.button`
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 6px;
  background: #007bff;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  white-space: nowrap;
  
  &:hover {
    background: #0056b3;
  }
`;

const ControlCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const ControlTitle = styled.h4`
  font-size: 1rem;
  color: #495057;
  margin: 0 0 0.5rem 0;
  font-weight: 600;
`;

const ControlDescription = styled.p`
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0 0 0.75rem 0;
  line-height: 1.4;
`;

const ControlActions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

const SmallButton = styled.button`
  padding: 0.5rem 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: ${props => props.variant === 'success' ? '#28a745' : 
                       props.variant === 'danger' ? '#dc3545' : 'white'};
  color: ${props => (props.variant === 'success' || props.variant === 'danger') ? 'white' : '#495057'};
  font-size: 0.75rem;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;

const MobileControlInfo = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [controlData, setControlData] = useState([]);

  // 더미 데이터
  useEffect(() => {
    setControlData([
      {
        id: 1,
        title: '사용자 접근 제어',
        description: '시스템 접근 권한을 관리하고 사용자별 권한을 설정합니다.',
        status: 'active'
      },
      {
        id: 2,
        title: '데이터 백업 설정',
        description: '자동 백업 주기와 백업 대상 데이터를 설정합니다.',
        status: 'inactive'
      },
      {
        id: 3,
        title: '시스템 모니터링',
        description: '시스템 리소스 사용량과 성능을 실시간으로 모니터링합니다.',
        status: 'active'
      },
      {
        id: 4,
        title: '로그 관리',
        description: '시스템 로그와 사용자 활동 로그를 관리합니다.',
        status: 'active'
      }
    ]);
  }, []);

  const handleSearch = () => {
    console.log('검색:', searchTerm);
  };

  const filteredData = controlData.filter(item => 
    item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <MobileSubNavigator 
      links={getHomeLinks()} 
      sectionTitle="제어정보"
      backPath="/"
      showBackButton={false}
    >
      <Container>
        <Header>
          <Title>시스템 제어 정보</Title>
          
          <SearchBox>
            <SearchInput
              type="text"
              placeholder="검색어를 입력하세요"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />
            <Button onClick={handleSearch}>검색</Button>
          </SearchBox>
        </Header>

        {filteredData.map((item) => (
          <ControlCard key={item.id}>
            <ControlTitle>{item.title}</ControlTitle>
            <ControlDescription>{item.description}</ControlDescription>
            
            <ControlActions>
              <SmallButton variant="success">
                {item.status === 'active' ? '활성' : '비활성'}
              </SmallButton>
              <SmallButton>설정</SmallButton>
              <SmallButton>상세보기</SmallButton>
            </ControlActions>
          </ControlCard>
        ))}

        {filteredData.length === 0 && (
          <ControlCard>
            <ControlDescription>검색 결과가 없습니다.</ControlDescription>
          </ControlCard>
        )}
      </Container>
    </MobileSubNavigator>
  );
};

export default MobileControlInfo;